//Todo time list
export const USER_ID_PROJECT_TIME_REQUEST = "USER_ID_PROJECT_TIME_REQUEST";
export const USER_ID_PROJECT_TIME_SUCCESS = "USER_ID_PROJECT_TIME_SUCCESS";
export const USER_ID_PROJECT_TIME_FAIL = "USER_ID_PROJECT_TIME_FAIL";

//Todo All Dated time list
export const USER_ID_PROJECT_ALL_BY_DATE_TIME_REQUEST =
  "USER_ID_PROJECT_ALL_BY_DATE_TIME_REQUEST";
export const USER_ID_PROJECT_ALL_BY_DATE_TIME_SUCCESS =
  "USER_ID_PROJECT_ALL_BY_DATE_TIME_SUCCESS";
export const USER_ID_PROJECT_ALL_BY_DATE_TIME_FAIL =
  "USER_ID_PROJECT_ALL_BY_DATE_TIME_FAIL";

//PROJECT Monthly time list
export const USER_ID_MONTH_PROJECT_TIME_REQUEST =
  "USER_ID_MONTH_PROJECT_TIME_REQUEST";
export const USER_ID_MONTH_PROJECT_TIME_SUCCESS =
  "USER_ID_MONTH_PROJECT_TIME_SUCCESS";
export const USER_ID_MONTH_PROJECT_TIME_FAIL =
  "USER_ID_MONTH_PROJECT_TIME_FAIL";

//PROJECT Range time list
export const USER_ID_RANGE_PROJECT_TIME_REQUEST =
  "USER_ID_RANGE_PROJECT_TIME_REQUEST";
export const USER_ID_RANGE_PROJECT_TIME_SUCCESS =
  "USER_ID_RANGE_PROJECT_TIME_SUCCESS";
export const USER_ID_RANGE_PROJECT_TIME_FAIL =
  "USER_ID_RANGE_PROJECT_TIME_FAIL";

//PROJECT list
export const USER_ID_PROJECT_REQUEST = "USER_ID_PROJECT_REQUEST";
export const USER_ID_PROJECT_SUCCESS = "USER_ID_PROJECT_SUCCESS";
export const USER_ID_PROJECT_FAIL = "USER_ID_PROJECT_FAIL";

//PROJECT DELETE
export const USER_ID_PROJECT_DELETE_REQUEST = "USER_ID_PROJECT_DELETE_REQUEST";
export const USER_ID_PROJECT_DELETE_SUCCESS = "USER_ID_PROJECT_DELETE_SUCCESS";
export const USER_ID_PROJECT_DELETE_FAIL = "USER_ID_PROJECT_DELETE_FAIL";

//PROJECT TIME DELETE
export const USER_ID_PROJECT_TIME_DELETE_REQUEST =
  "USER_ID_PROJECT_TIME_DELETE_REQUEST";
export const USER_ID_PROJECT_TIME_DELETE_SUCCESS =
  "USER_ID_PROJECT_TIME_DELETE_SUCCESS";
export const USER_ID_PROJECT_TIME_DELETE_FAIL =
  "USER_ID_PROJECT_TIME_DELETE_FAIL";

//project all list
export const USER_ID_ALL_PROJECT_REQUEST = "USER_ID_ALL_PROJECT_REQUEST";
export const USER_ID_ALL_PROJECT_SUCCESS = "USER_ID_ALL_PROJECT_SUCCESS";
export const USER_ID_ALL_PROJECT_FAIL = "USER_ID_ALL_PROJECT_FAIL";

//User Delete From Project
export const USER_DELETE_FROM_PROJECT_FROM_MANAGER_REQUEST =
  "USER_DELETE_FROM_PROJECT_FROM_MANAGER_REQUEST";
export const USER_DELETE_FROM_PROJECT_FROM_MANAGER_SUCCESS =
  "USER_DELETE_FROM_PROJECT_FROM_MANAGER_SUCCESS";
export const USER_DELETE_FROM_PROJECT_FROM_MANAGER_FAIL =
  "USER_DELETE_FROM_PROJECT_FROM_MANAGER_FAIL";
